import { observer } from 'mobx-react';

import SteppedComponent from 'js/components/pages/SteppedComponent';
import AppUser from 'js/stores/AppUser';
import AppState from 'js/stores/AppState';
import analytics from 'js/services/Analytics';
import { lightGrey1Color } from 'js/config/style';
import { validPrice } from 'js/services/Regex';
import { url } from 'js/services/Network';

import CreateTokenPageState from 'js/stores/pages/CreateTokenPageState';

import ItemDetails from './ItemDetails';
import PaymentMethod from './PaymentMethod';
import SignUpSignIn from './SignUpSignIn';

@observer
export default class CreateTokenPage extends SteppedComponent {
  pageName = 'CreateTokenPage';
  pageColor = lightGrey1Color;
  pageWidth = '375px';

  bootstrap = () => this.page.load();

  backNav = () =>
    AppUser.isLoggedIn
      ? AppState.previousPage === 'UserDashboardPage'
        ? {
            mode: 'back',
            text: 'Dashboard',
            url: url('user-dashboard-page'),
          }
        : {
            mode: 'back',
            text: 'My offers',
            url: url('my-tokens-page'),
          }
      : { mode: 'normal' };

  page = CreateTokenPageState.create().setSteps(this, 'create-offer-page', [
    {
      name: 'item',
      label: 'Item',
      component: ItemDetails,
      isComplete: (page, step) => validPrice(page.price) && page.title.length > 0,
      onEnter: (page, step) => { /*analytics.page('CC_viewed item details')*/ },
      showStepMenu: true,
    },
    {
      name: 'payment-method',
      label: 'Payment method',
      component: PaymentMethod,
      isComplete: (page, step) => page.credit_card.isFilledIn || page.bank_account.isFilledIn,
      onEnter: (page, step) => { /*analytics.page('CC_viewed payment method')*/ },
      showStepMenu: true,
    },
    {
      name: 'signup',
      label: 'Sign up',
      component: SignUpSignIn,
      onEnter: (page, step) => { /*analytics.page('CC_viewed sign up step')*/ },
      skipWhen: (page, step) => AppUser.isLoggedIn,
    },
  ]);
}
